var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to)?_c('a',{staticClass:"primary-link",attrs:{"href":_vm.to}},[_vm._t("default")],2):_c('button',{staticClass:"primary-link"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }